import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { buildAetUserContext, getPreferredUserIdentifier } from '../core/constant/user-context.util';
@Injectable({
  providedIn: 'root'
})
export class SafetyDashboardService {
  baseURL = environment.baseAPIURL;
  constructor( private readonly http  :HttpClient) { }
  getreport(user: any) {
    const url: string = environment.baseAPIURL + `/aetReport/aetSafetyDashboard`;
    const rb = { event: user, userReqDto: buildAetUserContext() };
    return this.http.post(url, rb, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
  }
  private handleError(error: HttpErrorResponse) {
    return throwError(error.message || "Server Error");
  }
  validateSafetyEventRoute(data) : Observable<any> {  
    const rb = { event: data, userReqDto: buildAetUserContext() };
    return this.http.put(this.baseURL+'/aetSafetyDashboard/validateSafetyEventRoute', rb).pipe(catchError(this.handleError));
  } 

  getDropdownData(): Observable<any> {
    return this.http
      .get(this.baseURL + '/aetSafetyDashboard/loadSafetyEventDetails')
      .pipe(
        catchError(() => this.http.get(this.baseURL + '/aetNotifications/GetCriteriaFilters')),
        catchError(this.handleError)
      );
  }

  submitCreateEvent(guid, data) : Observable<any> {  
    const userIdentifier = getPreferredUserIdentifier(guid);
    const requestBody = {
      event: data,
      userReqDto: buildAetUserContext(),
    };
    return this.http.post(`${this.baseURL}/aetSafetyDashboard/createSafetyEventRoute`, requestBody).pipe(catchError(this.handleError));
  } 
}
